// extracted by mini-css-extract-plugin
export default {"modal":"Modal__modal-Tuv9d","iconSelect":"Modal__iconSelect-bOHmg","options":"Modal__options-hmNrU","iconLabel":"Modal__iconLabel-Hri5r","textWrapper":"Modal__textWrapper-tASzV"};